import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { PreNotificationAdviceComponent } from './pre-notification-advice/pre-notification-advice.component';
import { LotPlanComponent } from './lot-plan/lot-plan.component';
import { LandholderConfirmationComponent } from './landholder-confirmation/landholder-confirmation.component';
import { LandholderDetailsComponent } from './landholder-details/landholder-details.component';
import { SelectPurposeComponent } from './select-purpose/select-purpose.component';
import { SelectCategoryComponent } from './select-category/select-category.component';
import { NotificationAreaComponent } from './notification-area/notification-area.component';
import { AcknowledgementsComponent } from './acknowledgements/acknowledgements.component';
import { ReviewNotificationComponent } from './review-notification/review-notification.component';
import { DeclarationsComponent } from './declarations/declarations.component';
import { AcknowledgeNotificationComponent } from './acknowledge-notification/acknowledge-notification.component';
import { SelfAuditComponent } from './self-audit/self-audit.component';
import { ExchangeAreaComponent } from './exchange-area/exchange-area.component';
import { SelectActivityComponent } from './select-activity/select-activity.component';
import { NotifierDetailsComponent } from './notifier-details/notifier-details.component';
import { SelectRegionalEcosystemStatusComponent } from './select-regional-ecosystem-status/select-regional-ecosystem-status.component';
import { ReasonComponent } from './reason/reason.component';
import { ChannelDimensionsComponent } from './channel-dimensions/channel-dimensions.component';
import { SelectRegionalEcosystemComponent } from './select-regional-ecosystem/select-regional-ecosystem.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    PreNotificationAdviceComponent,
    LotPlanComponent,
    LandholderConfirmationComponent,
    LandholderDetailsComponent,
    NotifierDetailsComponent,
    SelectPurposeComponent,
    SelectCategoryComponent,
    SelfAuditComponent,
    SelectActivityComponent,
    SelectRegionalEcosystemStatusComponent,
    NotificationAreaComponent,
    AcknowledgementsComponent,
    ReviewNotificationComponent,
    DeclarationsComponent,
    AcknowledgeNotificationComponent,
    ExchangeAreaComponent,
    ReasonComponent,
    ChannelDimensionsComponent,
    SelectRegionalEcosystemComponent
  ],
  exports: [
    PreNotificationAdviceComponent,
  ]
})
export class VegWizardModule { }
